import React, { useEffect, useState } from 'react'
import { Popup } from '../../../../components/Popup'
import CircledCloseIcon from '../../../../components/Images/CircledCloseIcon'
import ClipboardIcon from '../../../../components/Images/ClipboardIcon'
import WhatsAppIconNew from '../../../../components/Images/WhatsAppIconNew'
import InstagramIconNew from '../../../../components/Images/InstagramIconNew'
import FacebookIconNew from '../../../../components/Images/FacebookIconNew'
import TelegramIconNew from '../../../../components/Images/TelegramIconNew'
import {
  isMobileOrTablet,
  redirectToNovelLinkHandler,
  redirectToShowLinkHandler,
} from '../../../../lib/utils'
import * as Styles from './styles'
import { handleNewEventLog } from '../../../../lib/utils/events'

const SharePopup = ({
  isVisible,
  close,
  chapterId,
  userLanguage,
  userName,
  bookId,
  user,
  novelDetails,
}) => {
  const [isUrlCopyToClipboard, setIsUrlCopyToClipboard] = useState(false)
  const isMobile = window.screen.width < 600
  const shareLinkHandler = (appName) => {
    const url = `https://www.pocketnovel.com/shared-chapter/${bookId}?chapter_id=${chapterId}`
    let finalURL = ''
    const textWhileSharing =
      userLanguage === 'english'
        ? `
    Hello
    I wanted to share something with you. I have started writing a novel and have written the first part of my new story! 🚀 
    I would love it if you could give me your feedback after reading this. I want to know if you liked it and how I can improve. Click here:
    ${url}
    Your feedback will help and encourage me to move forward!
    Thanks a lot,
    ${userName}
    `
        : `
    हेलो
    आपसे कुछ शेयर करना थाI मैंने एक Novel लिखना शुरू किया है और अपनी नई कहानी का पहला हिस्सा लिख लिया है! 🚀
    मुझे बहुत अच्छा लगेगा अगर आप मुझे ये पढ़के अपना फीडबैक दे सकते हैंI  मुझे जानना है कि आपको क्या ये पसंद आया और मैं कैसे सुधार सकता हूँ। यहाँ क्लिक करें:
    ${url}
    आपके फीडबैक से मुझे आगे बढ़ने में मदद और प्रोत्साहन मिलेगाI
    बहुत धन्यवाद,
    ${userName}
    `

    if (appName === 'whatsapp')
      finalURL =
        'https://' +
        (isMobileOrTablet() ? 'api' : 'web') +
        '.whatsapp.com/send?text=' +
        encodeURIComponent(textWhileSharing)
    else if (appName === 'facebook')
      finalURL =
        'https://www.facebook.com/sharer/sharer.php?u=' +
        encodeURIComponent(url) +
        '&quote=' +
        encodeURIComponent(textWhileSharing)
    else if (appName === 'telegram')
      finalURL =
        'https://telegram.me/share/?url=' +
        encodeURIComponent(url) +
        '&text=' +
        encodeURIComponent(textWhileSharing)
    else if (appName === 'instagram')
      finalURL = 'https://www.instagram.com/?url=' + encodeURIComponent(url)
    else if (appName === 'clipboard') {
      handleNewEventLog(
        'chapter_editor',
        'novels_draft_chapter_link_copied',
        {
          route: window.location.pathname + window.location.search,
          button: 'copy_link',
          module_name: 'share_novel_module',
        },
        user,
        novelDetails
      )
      setIsUrlCopyToClipboard(true)
      if (isMobileOrTablet()) {
        var input = document.body.appendChild(document.createElement('input'))
        input.value = `${textWhileSharing}`
        input.focus()
        input.select()
        document.execCommand('copy')
        input.parentNode.removeChild(input)
        return
      }
      navigator.clipboard.writeText(url)
    }
    if (appName !== 'clipboard') return finalURL
  }

  useEffect(() => {
    return () => {
      setIsUrlCopyToClipboard(false)
    }
  }, [isVisible])

  function handleSocialMediaEvents(socialMedia) {
    handleNewEventLog(
      'chapter_editor',
      'novels_draft_chapter_shared',
      {
        route: window.location.pathname + window.location.search,
        button: socialMedia,
        module_name: 'share_novel_module',
      },
      user,
      novelDetails
    )
  }

  return (
    <Popup show={isVisible} close={close} className="share-popup">
      <Styles.PopupWrapper>
        {!isMobile && (
          <Styles.Header>
            <CircledCloseIcon onClick={close} />
          </Styles.Header>
        )}
        <Styles.BodyContent>
          <Styles.ShareHeading>
            Feel the thrill of instant feedback!
          </Styles.ShareHeading>
          <Styles.ShareSubHeading>
            Share your content with friends and family, let their <br></br>pride and
            guidance shape your journey
          </Styles.ShareSubHeading>
          <Styles.ShareActionsWrapper>
            <Styles.CircleWrapper
              href={shareLinkHandler('whatsapp')}
              target="_blank"
              onClick={() => handleSocialMediaEvents('whatsapp')}
            >
              <WhatsAppIconNew />
            </Styles.CircleWrapper>
            {/* <Styles.CircleWrapper
              href={shareLinkHandler('instagram')}
              target="_blank"
              onClick={() => handleSocialMediaEvents('instagram')}
            >
              <InstagramIconNew />
            </Styles.CircleWrapper> */}
            <Styles.CircleWrapper
              href={shareLinkHandler('facebook')}
              onClick={() => handleSocialMediaEvents('facebook')}
              target="_blank"
            >
              <FacebookIconNew />
            </Styles.CircleWrapper>
            <Styles.CircleWrapper
              href={shareLinkHandler('telegram')}
              onClick={() => handleSocialMediaEvents('telegram')}
              target="_blank"
            >
              <TelegramIconNew />
            </Styles.CircleWrapper>
            <Styles.CopyLinkWrapper
              onClick={() => shareLinkHandler('clipboard')}
            >
              <ClipboardIcon width="28px" height="28px" fill="#038ae3" />
              <p>Copy Link</p>
            </Styles.CopyLinkWrapper>
          </Styles.ShareActionsWrapper>
          <Styles.BottomWrapper>
            {isUrlCopyToClipboard && (
              <Styles.CopiedText>Link Copied !</Styles.CopiedText>
            )}
          </Styles.BottomWrapper>
        </Styles.BodyContent>
      </Styles.PopupWrapper>
    </Popup>
  )
}

export default SharePopup
